module.exports = __webpack_public_path__ + "static/media/Colette Stripe Queen Headboard - 155 cm_Dark Blue.15f22407.png";